import React from 'react';
import { ModalDialog } from './ModalDialog';

export function CreateCartErrorDialog({visible, type, onDismiss}) {
    const titles = {
        'tickets': 'Tickets are not available',
        'hotel': 'Hotel is not available',
        'unknown': 'Something went wrong',
    };

    const descriptions = {
        'tickets': 'Your chosen tickets are no longer available. Please pick new ones.',
        'hotel': 'Your chosen hotel is no longer available. Please select a new hotel.',
        'unknown': 'Something with your booking went wrong. Please try again.',
    };

    const title = titles[type] ? titles[type] : titles['unknown'];
    const description = descriptions[type]
        ? descriptions[type]
        : descriptions['unknown'];

    return (
        <ModalDialog
            visible={visible}
            primaryAction={onDismiss}
            primaryActionText={'Ok'}
            secondaryAction={onDismiss}
            icon="exclamation"
            header={title}
            body={description}
        />
    );
}
